import React from 'react';
import { Link } from 'react-router-dom';
// import { useThemeStore } from '../store/themeStore';

export const Footer = () => {
  // const { isDark, toggleTheme } = useThemeStore();

  return (
    <footer className="w-full py-8 border-t border-gray-100 dark:border-gray-800 mt-auto transition-colors">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-4">
        <div className="flex flex-wrap justify-center items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
          <a href="#" className="hover:text-black dark:hover:text-white transition-colors">FAQ</a>
          <span className="text-gray-400 dark:text-gray-600">•</span>
          <Link to="/privacy-policy" className="hover:text-black dark:hover:text-white transition-colors">Privacy Policy</Link>
          <span className="text-gray-400 dark:text-gray-600">•</span>
          <Link to="/terms-of-service" className="hover:text-black dark:hover:text-white transition-colors">Terms & Services</Link>
        </div>
        {/* Dark mode toggle - commented out for now, will use later */}
        {/* <button
          onClick={toggleTheme}
          className="text-sm text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          {isDark ? 'Light Mode' : 'Dark Mode'}
        </button> */}
      </div>
    </footer>
  );
};
